import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import "../pedagdocimage.css";

// ImageViewer component displays a full-size image or video
const ImageViewer = ({ image }) => {
  const [loaded, setLoaded] = React.useState(false);

  if (!image) {
    return null;
  }

  const isVideo = image.MimeType && image.MimeType.startsWith("video/");
  const fullSourceUrl = image.FullImageUrl || image.S3FullImageUrl;
  const fallbackThumbnailUrl = image.ThumbnailUrl || image.S3ThumbnailUrl;
  const videoViewerSource = fullSourceUrl || fallbackThumbnailUrl;

  return (
    <figure>
      <div className="pedagdoc-imageviewer-image">
        {!loaded && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1,
            }}
          >
            <CircularProgress size={48} />
          </Box>
        )}
        {isVideo ? (
          <video
            src={videoViewerSource}
            controls
            preload="metadata"
            onLoadedMetadata={() => setLoaded(true)}
            onError={() => setLoaded(true)}
            style={{
              opacity: loaded ? 1 : 0,
              maxWidth: "100%",
              maxHeight: "100vh",
            }}
          />
        ) : (
          <img
            src={fullSourceUrl || fallbackThumbnailUrl}
            alt="PedagDocFullImage"
            loading="lazy"
            decoding="async"
            onLoad={() => setLoaded(true)}
            onError={() => setLoaded(true)}
            style={{ opacity: loaded ? 1 : 0 }}
          />
        )}
        <figcaption>{image.ImgDescription}</figcaption>
      </div>
    </figure>
  );
};

export default ImageViewer;
